import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListaSeguimientoPage from "./grilla/lista-seguimiento";
import MapaSeguimientoPage from "./mapa/mapa-seguimiento";
import RuteoPage from "./mapa/ruteo";

const RouterSeguimiento = () => {
  const { path } = useRouteMatch();
  // console.log('RouterSeguimiento');
  // console.log(path);
  return (
    // <LayoutClientes>
    <Switch>

      <Route exact path={`${path}/listar-seguimiento`}>
        <ListaSeguimientoPage />
      </Route>

      <Route exact path={`${path}/mapa-seguimiento`}>
        <MapaSeguimientoPage />
      </Route>

      <Route exact path={`${path}/ruteo`}>
        <RuteoPage />
      </Route>

    </Switch>
    // </LayoutAsignacion>
  );
};

export default RouterSeguimiento;
